import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import { useGlobalConfigContext } from '../../../../global-config'
import { ProductPrescriptionDialog } from '../../../../product'
import { TENANT } from '../../../../tenant'
import { ProductSearchFlag } from '../../ProductSearchFlag'

export const ProductSearchResultItemPrescriptionRequiredLabel: FC = () => {
  const { tenant } = useGlobalConfigContext()

  const modalControls = useOpenableControls()

  // Modal isn't needed for CH as users will be redirected to MediService to buy Rx products
  if (tenant === TENANT.CH) {
    return (
      <ProductSearchFlag className="bg-light-secondary-medium capitalize">
        <FormattedMessage id="prescription.labels.prescriptionRequired" />
      </ProductSearchFlag>
    )
  }

  return (
    <>
      <ProductSearchFlag
        className="bg-light-secondary-medium capitalize"
        onClick={modalControls.handleOpen}
        slots={{
          root: 'button',
        }}
        type="button"
      >
        <FormattedMessage id="prescription.labels.prescriptionRequired" />
        <IconInfo className="ml-1 size-4" />
      </ProductSearchFlag>
      <ProductPrescriptionDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
